<template>
  <main class="container is-fluid columns is-centered">
    <div class="column is-half-desktop is-four-fifths-tablet">
      <div
        class="notification is-danger"
        v-if="error && typeof error === 'string'"
      >
        <button
          type="button"
          class="delete"
          v-on:click="error = null"
        ></button>
        {{ error }}
      </div>

      <form v-on:submit.prevent="login">
        <div class="field">
          <label class="label">E-mail address</label>
          <div class="control">
            <input
              type="email"
              v-model="email"
              class="input"
              :disabled="loading || undefined"
              required
              tabindex="1"
            />
          </div>
        </div>
        <div class="field">
          <div class="columns is-gapless label-columns">
            <div class="column">
              <label class="label">Password</label>
            </div>
            <div class="column is-narrow">
              <router-link
                :to="{ name: 'password-reset' }"
                tabindex="-1"
              >
                Forgot your password?
              </router-link>
            </div>
          </div>
          <div class="control">
            <input
              type="password"
              v-model="password"
              class="input"
              :disabled="loading || undefined"
              required
              tabindex="2"
            />
          </div>
        </div>
        <div class="field is-grouped is-grouped-centered">
          <p class="control">
            <button
              type="submit"
              class="button is-primary"
              :class="{ 'is-loading': loading }"
              :disabled="!email || !password || loading || undefined"
              tabindex="3"
            >
              Login
            </button>
          </p>
        </div>
      </form>

      <template v-if="authStore.hasFeature('oidc')">
        <hr />
        <div class="field is-grouped is-grouped-centered">
          <p class="control">
            <a
              type="button"
              class="button"
              :href="oidcLoginUrl"
            >
              Login using OpenID Connect
            </a>
          </p>
        </div>
      </template>
    </div>
  </main>
</template>

<script lang="ts">
import { mapStores } from 'pinia'
import { defineComponent } from 'vue'

import { API_BASE_URL } from '@/config'
import { errorParser } from '@/helpers'
import { useAuthStore } from '@/stores'

export default defineComponent({
  data: () => ({
    email: '',
    password: '',
    loading: false,
    error: null as string | null,
  }),
  computed: {
    ...mapStores(useAuthStore),
    oidcLoginUrl(): string {
      return new URL(
        `/oidc/sso-login?next=${encodeURIComponent(document.location.href)}`,
        API_BASE_URL,
      ).toString()
    },
  },
  methods: {
    async login() {
      this.loading = true
      try {
        await this.authStore.login({
          email: this.email,
          password: this.password,
        })
      } catch (err) {
        this.error = errorParser(err)
      } finally {
        this.loading = false
      }
    },
    tryRedirect() {
      if (!this.authStore.isLoggedOn) return
      if (typeof this.$route.query?.next === 'string') this.$router.replace(this.$route.query.next)
      else this.$router.push({ name: 'corpus-list' })
    },
  },
  watch: {
    // Use a watched property in case another request runs and updates the current user
    'authStore.user': {
      immediate: true,
      handler: 'tryRedirect',
    },
  },
})
</script>

<style scoped>
.columns.label-columns:not(:last-child) {
  margin-bottom: 0.5rem;
}
</style>
